import React from 'react';
import IconWarning from '../../../../icons/icon-warning/icon-warning';
import IconExclamation from '../../../../icons/icon-exclamation/icon-exclamation';
import { FONT_COLOR } from '../../../../fonts/font-props';
import FontBody1 from '../../../../fonts/font-body1/font-body1';
import Icon from '../../../../icons/icon/icon';

enum NOTIFICATION_LINK_TYPE {
    WARNING = 'warning',
    INFO = 'info'
}

interface AppHeaderNotificationLinkProps {
    type: NOTIFICATION_LINK_TYPE;
    href: string;
    text: string;
}

const AppHeaderNotificationLink: React.FC<AppHeaderNotificationLinkProps> = ({
    type,
    href,
    text,
}) => {
    const isWarning = type === NOTIFICATION_LINK_TYPE.WARNING;
    const IconComponent = isWarning ? IconWarning : IconExclamation;
    const iconColor = isWarning ? 'var(--color-accent-4)' : 'var(--color-accent-1)';
    const linkClass = `header-notification-link header-notification-link--${type}`;

    return (
        <a
            className={linkClass}
            href={href}
            target="_top"
        >
            <Icon Component={IconComponent} color={iconColor} />
            <FontBody1 color={FONT_COLOR.PRIMARY2}>{text}</FontBody1>
        </a>
    );

};

export { NOTIFICATION_LINK_TYPE };
export default AppHeaderNotificationLink;
